<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite licence"
  (onChange)="selectedItemsOnChange()"
></p-multiSelect>
